import React, {useMemo, useCallback} from "react";
import {Modal, Button} from "antd";
import classNames from "classnames";
import {buildWazeUrl, buildGoogleMapsUrl} from "./utils";

export const DeliveryNavigateModal = ({open, location, onClose}) => {
    const addressText = useMemo(() => {
        return location?.address || location?.formattedAddress || location?.displayName || "";
    }, [location]);

    const wazeUrl = useMemo(() => buildWazeUrl(location), [location]);
    const googleMapsUrl = useMemo(() => buildGoogleMapsUrl(location), [location]);

    const handleNavigate = useCallback(
        url => {
            if (!url) {
                return;
            }
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

            if (isMobile) {
                const link = document.createElement("a");
                link.href = url;
                link.rel = "noopener noreferrer";
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    if (document.body.contains(link)) {
                        document.body.removeChild(link);
                    }
                }, 100);
            } else {
                window.open(url, "_blank", "noopener,noreferrer");
            }

            onClose?.();
        },
        [onClose]
    );

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            closable={false}
            wrapClassName="delivery-navigation-modal-wrap"
            className={classNames("delivery-navigation-modal")}>
            <div className="delivery-navigation-modal__header">
                <div className="delivery-navigation-modal__title">התחל נסיעה</div>
                {addressText && <div className="delivery-navigation-modal__subtitle">{addressText}</div>}
            </div>

            <div className="delivery-navigation-modal__actions">
                <Button size="large" block onClick={() => handleNavigate(googleMapsUrl)} disabled={!googleMapsUrl}>
                    נווט עם גוגל מפות
                </Button>
                <Button size="large" block onClick={() => handleNavigate(wazeUrl)} disabled={!wazeUrl}>
                    נווט עם וויז
                </Button>
                <Button size="large" style={{color: "var(--link-color)", fontWeight: "bold"}} block onClick={onClose}>
                    ביטול
                </Button>
            </div>
        </Modal>
    );
};
